import {
  changeBackground,
  createEl,
  hideAllElements,
  buttonDisabled,
} from "./helpers.js";
import { startPhoneAnimation } from "./phone-animation.js";

const symbolAssets = {
  cat: "/assets/img/cat.webp",
  lantern: "/assets/img/lantern.webp",
  redBag: "/assets/img/red-bag.webp",
  wild: "/assets/img/wild.webp",
  paper: "/assets/img/paper.webp",
  gold: "/assets/img/gold.webp",
  frog: "/assets/img/frog.webp",
};

const WIN_ICON_SRC = "/assets/img/ball-win.webp";

const reelOneSymbols = [
  "cat",
  "lantern",
  "redBag",
  "wild",
  "wild",
  "paper",
  "gold",
  "frog",
];

const reelTwoSymbols = [
  "wild",
  "wild",
  "paper",
  "frog",
  "gold",
  "cat",
  "redBag",
  "lantern",
];

const reelThreeSymbols = [
  "gold",
  "frog",
  "redBag",
  "paper",
  "lantern",
  "wild",
  "cat",
];

let currentSpinTarget = null;
let spinCount = 0;
let currentBalance = 1000000;
let currentBet = 7000;

const targetPositions = [
  { reels: [25, 20, 18] },
  { reels: [23, 17, 20] },
  { reels: [20, 25, 26], showWin: true },
  { reels: [19, 24, 25], showWin: true },
];

let cachedIconHeight = null;
let cachedItemHeight = null;

export function createReel(symbols) {
  const iconsContainer = createEl("div", "icons-container");

  for (let i = 0; i < 30; i++) {
    const slotContainer = createEl("div", "slot-container");
    const ballWin = createEl("img", "slot-icon-win");
    ballWin.src = WIN_ICON_SRC;
    const img = createEl("img", "slot-icon");
    const symbol = symbols[i % symbols.length];
    img.dataset.symbol = symbol;
    img.src = symbolAssets[symbol];
    slotContainer.append(img, ballWin);
    iconsContainer.append(slotContainer);
  }
  return iconsContainer;
}

export function initializeReels() {
  const credit = document.querySelector(".credit");
  const slotMachine = document.querySelector(".slot-machine");
  const reelOne = document.querySelector(".reel_one");
  const reelTwo = document.querySelector(".reel_two");
  const reelThree = document.querySelector(".reel_three");

  if (!credit || !slotMachine || !reelOne || !reelTwo || !reelThree) return;

  credit.style.display = "block";
  slotMachine.style.display = "block";

  reelOne.append(createReel(reelOneSymbols));
  reelTwo.append(createReel(reelTwoSymbols));
  reelThree.append(createReel(reelThreeSymbols));

  calculateHeights();
  initResizeHandlers();
}

function calculateHeights() {
  const slotIcon = document.querySelector(".slot-container");
  if (!slotIcon) return;

  cachedIconHeight = parseFloat(
    slotIcon.getBoundingClientRect().height.toFixed(2)
  );
  const gap = 10;
  cachedItemHeight = cachedIconHeight + gap;
}

function calculateSpinToTarget(targetIndices) {
  if (!cachedItemHeight) {
    calculateHeights();
  }
  return targetIndices.map((index) => -index * cachedItemHeight);
}

function applyReelPositions(reels, positions) {
  reels.forEach((reel) => {
    void reel.offsetHeight;
  });

  requestAnimationFrame(() => {
    reels.forEach((reel, index) => {
      reel.style.transition = "transform 3s cubic-bezier(0.2, 0.8, 0.3, 1)";
      reel.style.transform = `translateY(${positions[index]}px)`;
    });
  });
}

function updateReelsPosition() {
  const reels = document.querySelectorAll(".reel");

  if (currentSpinTarget) {
    const positions = calculateSpinToTarget(currentSpinTarget.reels);

    reels.forEach((reel) => {
      void reel.offsetHeight;
    });

    reels.forEach((reel, index) => {
      reel.style.transition = "none";
      reel.style.transform = `translateY(${positions[index]}px)`;
    });
  }
}

let resizeTimeout;

function handleResize() {
  const reels = document.querySelectorAll(".reel");

  cachedIconHeight = null;
  cachedItemHeight = null;

  reels.forEach((reel) => {
    void reel.offsetHeight;
  });

  updateReelsPosition();
}

function initResizeHandlers() {
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  });

  window.addEventListener("orientationchange", () => {
    setTimeout(handleResize, 500);
  });
}

function showWinAnimations(reels) {
  reels.forEach((reel) => {
    const winIcons = reel.querySelectorAll(".slot-icon-win");
    const slotIcons = reel.querySelectorAll(".slot-icon");

    slotIcons.forEach((slotIcon, index) => {
      if (slotIcon.dataset.symbol === "wild") {
        if (winIcons[index]) {
          winIcons[index].style.opacity = "1";
          slotIcon.classList.add("anim");
        }
      }
    });
  });
}

export function spinMachine() {
  const reels = document.querySelectorAll(".reel");
  const target = targetPositions[spinCount];
  currentSpinTarget = target;
  const creditBalans = document.querySelector(".credit__balans");
  const winBlock = document.querySelector(".slot-win");

  window.playSlotSpinSound();

  buttonDisabled(true, "none");
  currentBalance -= currentBet;
  creditBalans.textContent = currentBalance;

  const allWinIcons = document.querySelectorAll(".slot-icon-win");
  allWinIcons.forEach((icon) => {
    icon.style.opacity = "0";
  });

  const slotIcons = document.querySelectorAll(".slot-icon");
  slotIcons.forEach((icon) => {
    icon.classList.remove("anim");
  });

  reels.forEach((reel) => {
    void reel.offsetHeight;
  });

  reels.forEach((reel) => {
    reel.style.transition = "none";
    reel.style.transform = "translateY(0)";
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const positions = calculateSpinToTarget(target.reels);
      applyReelPositions(reels, positions);

      setTimeout(() => {
        buttonDisabled(false, "block");

        if (target.showWin) {
          if (spinCount === 2) {
            window.threeSpinSound();
            currentBalance += 250000;
            winBlock.textContent = "상금 250,000 ₩";
          } else if (spinCount === 3) {
            window.winSpinSound();
            currentBalance += 600000;
            winBlock.textContent = "상금 600,000 ₩";
            buttonDisabled(true, "none");
            cashOut();
          }

          creditBalans.textContent = currentBalance;
          showWinAnimations(reels);

          setTimeout(() => {
            winBlock.textContent = "0.000,00 ₩";
          }, 3000);
        }

        spinCount++;
      }, 3000);
    });
  });
}

const elementsToHideSlot = [
  ".tiger",
  ".credit",
  ".slot-machine",
  ".button-spin",
  ".cash-out",
  ".wallet",
];

function cashOut() {
  const cashOutBtn = document.querySelector(".cash-out");
  const wallet = document.querySelector(".wallet");
  const logo = document.querySelector(".logo");

  if (!cashOutBtn || !wallet || !logo) return;

  cashOutBtn.style.display = "block";
  wallet.style.display = "block";

  cashOutBtn.addEventListener("click", () => {
    logo.style.display = "none";
    hideAllElements(elementsToHideSlot);
    changeBackground("none");
    startPhoneAnimation();
  });
}
